/**
 *  Campaigns state module file
**/

export const state = {
  meta: {
    loading: false,
    count: 0
  },
  campaings_compare: [],
  copy_tasks: {
    meta: {
      loading: false,
      count: 0,
      page: 1,
      page_size: 10
    },
    results: []
  }
}
